/* eslint-disable react/style-prop-object */
const ArrowUp: React.FC = () => {
  return (
    <svg
      className="svg-icon"
      style={{
        width: "1em",
        height: "1em",
        verticalAlign: "middle",
        fill: "black",
        overflow: "hidden",
      }}
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M890.595556 674.891852 525.463704 322.275556c-1.232593-1.137778-2.56-2.085926-3.982222-2.939259-7.205926-4.361481-16.592593-3.508148-22.945185 2.56L133.404444 674.607407c-7.68 7.395556-7.774815 19.816296 0 27.306667 7.395556 7.205926 19.342222 6.826667 26.737778-0.379259l351.762963-339.626667c0 0 0 0 0.094815 0l352.047407 340.005926c7.395556 7.205926 19.342222 7.49037 26.737778 0.379259C898.37037 694.708148 898.275556 682.287407 890.595556 674.891852z" />
    </svg>
  );
};

export default ArrowUp;
